module.exports = __webpack_public_path__ + "static/media/LabourCard-II.c4d63e60.svg";